import React from "react";
import { useTranslation } from "react-i18next";
import { ListFilter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const FILTER_BUTTON_CLASSES =
  "w-fit gap-2 min-h-8 h-8 border border-slate-200 py-1 text-foreground text-sm font-medium shadow-xs";

export function GuesteriaPartnersFilterButton(
  props: Omit<React.ComponentProps<typeof Button>, "variant" | "type">,
): React.JSX.Element {
  const { t } = useTranslation();
  const { className, children, ...rest } = props;
  return (
    <Button
      type="button"
      variant="icon-text"
      className={cn(FILTER_BUTTON_CLASSES, className)}
      {...rest}
    >
      {children ?? (
        <>
          <ListFilter className="size-4" />
          {t("partners.table.filters")}
        </>
      )}
    </Button>
  );
}
